import { useTranslation } from "react-i18next";
import { useState, useRef } from 'react';

import restIMG from "./img/imagepreview.png";
import telegramIMG from "./img/tg.png";
import mailIMG from "./img/mail.png";

import {useNavigate} from "react-router-dom";

function Info() {
    //const navigate = useNavigate();

    //const api_url = "https://spwc-order-site.me/api/createOrder/"

    const { t, i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const contactRef = useRef(null);

    const scrollToContact = () => {
        contactRef.current?.scrollIntoView({ behavior: 'smooth' });
    }

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        comment: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    //const handleSubmit = async (e) => {
    //    e.preventDefault();

    //    try {
    //        const response = await fetch(api_url, {
    //            method: 'POST',
    //            headers: {
    //                'Content-Type': 'application/json',
    //            },
    //            body: JSON.stringify(formData),
    //        });

    //        if (response.ok) {
    //            setFormData({ name: "", email: "", comment: "" });
    //            console.log("response", response);
    //        }
    //    } catch (error) {
    //        console.error(error);
    //    }
    //};

    return (
        <main>
            <section className="baner">
                <div className="baner-content">
                    <h1>{t("info.banner.title")}</h1>
                    <p>{t("info.banner.desc")}</p>
                    <div className="baner-btn">
                        <button className="btn-primary" onClick={scrollToContact}>
                            {t("info.banner.btn")}
                        </button>
                    </div>
                </div>
            </section>

            <section className="portfolio-case">
                <div className="case-container">
                    <div className="case-info">
                        <h2>{t("info.portfolio.title")}</h2>
                        <p>{t("info.portfolio.desc")}</p>

                        <ul className="feature-list">
                            <li>
                                <span className="check-icon">✓</span>
                                <span><strong>{t("info.portfolio.feature1_title")}</strong> {t("info.portfolio.feature1_desc")}</span>
                            </li>
                            <li>
                                <span className="check-icon">✓</span>
                                <span><strong>{t("info.portfolio.feature2_title")}</strong> {t("info.portfolio.feature2_desc")}</span>
                            </li>
                            <li>
                                <span className="check-icon">✓</span>
                                <span><strong>{t("info.portfolio.feature3_title")}</strong> {t("info.portfolio.feature3_desc")}</span>
                            </li>
                        </ul>

                        <div className="case-actions">
                            <div>
                                <a href="https://red-dragon.me/" target="_blank" rel="noreferrer" className="btn-primary">
                                    {t("info.portfolio.btn")}
                                </a>
                            </div>
                            <div>
                                <p> {t("info.portfolio.btn_info")}</p>
                            </div>

                        </div>
                    </div>
                    <div className="case-visual">
                        <div className="mockup-mini">
                            <img src={restIMG} alt="Red Dragon Mockup" />
                        </div>
                    </div>
                </div>
            </section>

            <section className="how-it-works">
                <h2 className="section-title">{t("info.howItWorks.title")}</h2>
                <div className="steps-grid">
                    <div className="step-card">
                        <div className="step-number">01</div>
                        <h3>{t("info.howItWorks.step1_title")}</h3>
                        <p>{t("info.howItWorks.step1_desc")}</p>
                    </div>
                    <div className="step-card">
                        <div className="step-number">02</div>
                        <h3>{t("info.howItWorks.step2_title")}</h3>
                        <p>{t("info.howItWorks.step2_desc")}</p>
                    </div>
                    <div className="step-card">
                        <div className="step-number">03</div>
                        <h3>{t("info.howItWorks.step3_title")}</h3>
                        <p>{t("info.howItWorks.step3_desc")}</p>
                    </div>
                </div>
            </section>

            <section className="pricing">
                <h2 className="section-title">{t("info.pricing.title")}</h2>
                <p className="section-subtitle">{t("info.pricing.subtitle")}</p>
                <div className="table-container">
                    <table className="pricing-table">
                        <thead>
                        <tr>
                            <th>{t("info.pricing.th_type")}</th>
                            <th>{t("info.pricing.th_desc")}</th>
                            <th>{t("info.pricing.th_time")}</th>
                            <th>{t("info.pricing.th_price")}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="td-title">{t("info.pricing.service1_title")}</td>
                            <td>{t("info.pricing.service1_desc")}</td>
                            <td>{t("info.pricing.service1_time")}</td>
                            <td className="td-price">{t("info.pricing.service1_price")}</td>
                        </tr>
                        <tr>
                            <td className="td-title">{t("info.pricing.service2_title")}</td>
                            <td>{t("info.pricing.service2_desc")}</td>
                            <td>{t("info.pricing.service2_time")}</td>
                            <td className="td-price">{t("info.pricing.service2_price")}</td>
                        </tr>
                        <tr>
                            <td className="td-title">{t("info.pricing.row2_title")}</td>
                            <td>{t("info.pricing.row2_desc")}</td>
                            <td>{t("info.pricing.row2_time")}</td>
                            <td className="td-price">{t("info.pricing.price2")}</td>
                        </tr>
                        <tr>
                            <td className="td-title">{t("info.pricing.row3_title")}</td>
                            <td>{t("info.pricing.row3_desc")}</td>
                            <td>{t("info.pricing.row3_time")}</td>
                            <td className="td-price">{t("info.pricing.price3")}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <section className="faq-section">
                <h2 className="section-title">{t("info.faq.title")}</h2>
                <div className="faq-container">
                    <details className="faq-item">
                        <summary>{t("info.faq.q1")}</summary>
                        <p className="faq-answer">{t("info.faq.a1")}</p>
                    </details>
                    <details className="faq-item">
                        <summary>{t("info.faq.q2")}</summary>
                        <p className="faq-answer">{t("info.faq.a2")}</p>
                    </details>
                    <details className="faq-item">
                        <summary>{t("info.faq.q3")}</summary>
                        <p className="faq-answer">{t("info.faq.a3")}</p>
                    </details>
                    <details className="faq-item">
                        <summary>{t("info.faq.q4")}</summary>
                        <p className="faq-answer">{t("info.faq.a4")}</p>
                    </details>
                </div>
            </section>

            <section className="contact-section" ref={contactRef}>
                <div className="contact-card">
                    <div className="contact-content">
                        <h2>{t("info.contact.title")}</h2>

                        <a className="contact-info-tg"
                           style={{
                               alignItems: "center",
                               display: "flex",
                               gap: "10px",
                               marginBottom: "16px"
                           }}
                           href="https://t.me/SerializerF">
                            <img src={telegramIMG} width="50px"/>
                            <p className="contact-info-tg"
                               style={{
                                   color: "white",
                                   backgroundColor: "transparent",
                                   border: "none",
                                   cursor: "pointer"
                               }
                               }>
                                @SerializerF
                            </p>
                        </a>

                        <div className="contact-info-mail">
                            <img src={mailIMG} width="50px"/>
                            <p>specialwebcreation@gmail.com</p>
                        </div>

                        {/*<form className="contact-form" onSubmit={handleSubmit}>*/}
                        {/* <input*/}
                        {/* type="text"*/}
                        {/* name="name"*/}
                        {/* value={formData.name}*/}
                        {/* onChange={handleChange}*/}
                        {/* placeholder={t("info.contact.placeholder_name")}*/}
                        {/* required*/}
                        {/* />*/}
                        {/* <input*/}
                        {/* type="text"*/}
                        {/* name="email"*/}
                        {/* value={formData.email}*/}
                        {/* onChange={handleChange}*/}
                        {/* placeholder={t("info.contact.placeholder_email")}*/}
                        {/* required*/}
                        {/* />*/}
                        {/* <textarea*/}
                        {/* name="comment"*/}
                        {/* value={formData.comment}*/}
                        {/* onChange={handleChange}*/}
                        {/* placeholder={t("info.contact.placeholder_project")}*/}
                        {/* rows={5}*/}
                        {/* />*/}

                        {/* <button type="submit" className="btn-submit-form">*/}
                        {/* {t("info.contact.btn")}*/}
                        {/* </button>*/}
                        {/* <button*/}
                        {/* type="button"*/}
                        {/* style={{*/}
                        {/* fontSize: '12px',*/}
                        {/* marginTop: '10px',*/}
                        {/* color: "white",*/}
                        {/* backgroundColor: "transparent",*/}
                        {/* border: "none",*/}
                        {/* textDecoration: "underline",*/}
                        {/* cursor: "pointer"*/}
                        {/* }}*/}
                        {/* onClick={() => navigate("/privacy")}*/}
                        {/* >*/}
                        {/* {t("legal.agreement_text")}*/}
                        {/* </button>*/}
                        {/*</form>*/}
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Info;